// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"977a9db0","54":"4e4d337f","77":"af2fa230","404":"794c1911","415":"8ba71937","450":"8ba71937","511":"8ba71937","578":"3266e8c5","606":"8ba71937","707":"9c851fea","756":"8ba71937","807":"f54c7fa2","926":"70caf513"}[chunkId] + ".chunk.css";
};